import { tempoApi } from '@/lib/api/tempoApi';
import type { TeamRole } from '@/lib/api/types/teamRoles';

const getTeamRoles = async (): Promise<TeamRole[]> => {
  return await tempoApi().get('api/v1/capacity/team-roles').json<TeamRole[]>();
};

const createTeamRole = async (name: string): Promise<TeamRole> => {
  return await tempoApi().post('api/v1/capacity/team-roles', { json: { name } }).json<TeamRole>();
};

const updateTeamRole = async (id: number, name: string): Promise<TeamRole> => {
  return await tempoApi()
    .put(`api/v1/capacity/team-roles/${id}`, { json: { name } })
    .json<TeamRole>();
};

const deleteTeamRole = async (id: number): Promise<void> => {
  return await tempoApi().delete(`api/v1/capacity/team-roles/${id}`).json();
};

export const TeamRolesApi = {
  getTeamRoles,
  createTeamRole,
  updateTeamRole,
  deleteTeamRole,
} as const;
